function bind(el, binding) {
    if (!binding.value) {
        return
    }

    el.setAttribute('data-dialog', '')
    const container = el.ownerDocument.createElement('div')
    container.className = binding.arg ?? Object.keys(binding.modifiers).join(' ')
    container.setAttribute('data-dialog-text', '')
    container.innerText = binding.value
    el.appendChild(container)
}

function beforeUpdate(el, binding) {
    const container = el.querySelector('[data-dialog-text]')

    if (!binding.value) {
        if (container) {
            el.removeAttribute('data-dialog')
            el.removeChild(container)
        }
    } else if (container) {
        container.innerText = binding.value
    }
}

export default {
    name: 'dialog',
    wireup: {
        bind,
        beforeUpdate,
        // Vue 2
        componentUpdated: beforeUpdate,
    },
}
